// Constants:
const ROUTES = {
  INDEX: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  HOME: '/home',
  CASH_DIARY: '/cash-diary',
  RETAILS_CASH: '/retails-cash',
  PASSWORDS: '/passwords',
  PIN_LIST: '/pin-list',
  PIN_LIST_HAI: '/pin-lists',
  MILEAGE_TRACKING: '/mileage-tracking',
  LOCKERS: '/lockers',
  REAL_ESTATE: '/real-estate',
  // SUGGEST_US: '/vault-receipt',
  VAULT_RECEIPT:'/vault-receipt',
  LOGOUT: '/logout',
  CHANGE_PASSWORD: '/change-password',
  VIEW_PROFILE: '/profile',
  FORGET_PASSWORD: '/forgot-password',
  SECRET_PIN :'/secret-pin',
  MY_LOCATIONS :'/location',
  THANKYOUFORREGISTRATION:'/welcome',
  OPENDOWNLOADIMAGE: '/view-file',
  PRIVACYPOLICY:'/privacy-policy'
}

// Exports:
export default ROUTES
